import { Group } from '@mantine/core';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { technologicalTransferDomains } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferSchema } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { EnumSelectControl, TextInputControl } from '@/core/components';

export interface TechnologicalTransferDomainSelectControlProps {
  isSubmitting: boolean;
  watch: UseFormWatch<TechnologicalTransferSchema>;
}

export const TechnologicalTransferDomainSelectControl = (props: TechnologicalTransferDomainSelectControlProps) => {
  const { isSubmitting, watch } = props;
  const { t } = useTranslation();

  const domainField = watch('domain');
  const showDomainNameField = domainField === 'OTHER';

  return (
    <Group>
      <EnumSelectControl<TechnologicalTransferSchema>
        withAsterisk
        name="domain"
        label={t('technologicalTransfers.form.fields.domain')}
        isSubmitting={isSubmitting}
        options={technologicalTransferDomains.map(type => ({
          value: type,
          label: t(`technologicalTransfers.domainEnum.${type}`),
        }))}
      />
      {showDomainNameField && (
        <TextInputControl<TechnologicalTransferSchema>
          withAsterisk
          name="domainName"
          label={t('technologicalTransfers.form.fields.domainName')}
          isSubmitting={isSubmitting}
        />
      )}
    </Group>
  );
};
